
<div class="fixed top-2 inset-x-0 px-2 z-20 md:inset-x-auto md:right-2 md:px-0">
  @for (t of toastrs; track t) {
    <div class="mb-2 w-full md:w-auto">
      <app-toastr [toastr]="t"></app-toastr>
    </div>
  }
</div>
